// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__8Q3JE","mainContent":"MainLayout_mainContent__Hh4mp","mobileMenuOpen":"MainLayout_mobileMenuOpen__CH3yN"};